import React from 'react';
import { observer } from 'mobx-react';
import { useAnalyticsStore } from '~contexts/mobx';
import style from './style.module.scss';

/**
 * Thin load bar for the standardized KPI dashboards. Reads the store's KPI load
 * counters (settled/total of the current batch of envelope requests) and fills
 * 0..100% as requests come back, then fades out. Place it once on a dashboard;
 * it needs no props and no provider.
 */
export const KpiLoadProgressBar: React.FC = observer(() => {
    const analyticsStore = useAnalyticsStore();
    const pct = Math.round(analyticsStore.kpiLoadPercent * 100);
    const active = analyticsStore.kpiLoadActive;

    return (
        <div
            className={style.track}
            data-active={active}
            role="progressbar"
            aria-valuenow={pct}
            aria-valuemin={0}
            aria-valuemax={100}
            aria-hidden={!active}
        >
            <div
                className={style.fill}
                data-zero={pct === 0}
                style={{ width: `${pct}%` }}
            />
        </div>
    );
});
